const closeLanguageSwitch = () => {
  toggleBodyScrollLock(false);
  document.querySelector('.language-switch__form.is-open')?.classList.remove('is-open');
};

attachEvent('.language-switch__button', 'click', () => {
  toggleBodyScrollLock(true);
  document.querySelector('.language-switch__form')?.classList.add('is-open');
});

attachEvent(
  '.language-switch__form-close, .language-switch__form-overlay, [data-language-submit]',
  'click',
  closeLanguageSwitch,
);

onKeydown('Escape', closeLanguageSwitch);
